var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection1Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 56,
    viewBox: "0 0 54 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.9283 3.07106C43.228 -3.22859 53.9994 1.23309 53.9994 10.1421L53.9994 29C53.9994 34.5229 49.5222 39 43.9994 39L25.1415 39C16.2324 39 11.7708 28.2286 18.0704 21.9289L36.9283 3.07106Z",
    fill: "#15803D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6667 54.3332L1 40.9998M43.6667 54.3332H1V40.9998L43.6667 54.3332ZM43.6667 54.3332V32.9998C43.6667 21.2178 34.1155 11.6665 22.3333 11.6665C20.2152 11.6665 18.1693 11.9752 16.2381 12.5499C7.42595 15.1726 1 23.3358 1 32.9998V40.9998L43.6667 54.3332Z",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 25V27.6667",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 22.3335V25.0002",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 19.6665V22.3332",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection1Svg2);
export default __webpack_public_path__ + "static/media/section1svg2.6e597c3ef8975d6663711665368657f8.svg";
export { ForwardRef as ReactComponent };